import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, mergeProps as _mergeProps, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { style: {"width":"36px"} }
const _hoisted_3 = {
  class: "iconDraw",
  version: "1.0",
  xmlns: "http://www.w3.org/2000/svg",
  width: "25px",
  viewBox: "0 0 300.000000 300.000000"
}
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { key: 2 }

import { computed, onMounted, ref, watch } from "vue";
import router from "@/router";

/********************************
 ************ VUETIFY ***********
 *******************************/
import { useDisplay } from "vuetify";
import { useStore } from "vuex";
import { useI18n } from "vue-i18n";
import { VISIBLE_PAGES, STRING_GENERAL, NAME_PROJECT } from "@/constants/labels";
import { COLORS_IN_HTML } from "@/constants/colors";
import CONSTANTSVG from "@/constants/svg";

/********************************
 ********** INTERFACES **********
 *******************************/
import { SIDEBAR } from "@/interfaces/SmartLink/Admin";

// let userROL = localStorage.getItem("rol");
// let finalRolUser = userROL ? parseInt(userROL) : 0;


export default /*@__PURE__*/_defineComponent({
  __name: 'DrawerBar',
  setup(__props) {

const { mobile } = useDisplay();

/********************************
 ************ STORE *************
 *******************************/
const store = useStore();

/********************************
 ************ I18N **************
 *******************************/
const { t } = useI18n();

/********************************
 ********** CONSTANTES **********
 *******************************/
const colorDrawer = computed(() => COLORS_IN_HTML.value.drawer);

const projectName = computed(() => store.state.projectName);
const isDEMO = computed(() => projectName.value === NAME_PROJECT.demo);
const isRAOS = computed(() => projectName.value === NAME_PROJECT.raos);
const isLIMA= computed(() => projectName.value === NAME_PROJECT.lima);
const isNacozari = computed(() => projectName.value === NAME_PROJECT.nacozari);
const isCollahuasi = computed(() => projectName.value === NAME_PROJECT.collahuasi);
const isCananea = computed(() => projectName.value === NAME_PROJECT.cananea);
const isTepeaca = computed(() => projectName.value === NAME_PROJECT.tepeaca);

const SIDEBAR_ITEMS: SIDEBAR = {
  DASHBOARD: isRAOS.value
    ? [
        {
          icon: "mdi-dump-truck",
          title: computed(() => t("sidebar.raos")),
          value: VISIBLE_PAGES.raospg,
        },
      ]
    : [
        {
          icon: "mdi-developer-board",
          title: computed(() => t("labels.dashboard")),
          value: VISIBLE_PAGES.dashboard,
        },
      ],
  FIRSTS: [
    {
      icon: CONSTANTSVG.pmpap,
      title: computed(() => t("labels.distribution")),
      value: STRING_GENERAL.distri,
    },
    {
      icon: CONSTANTSVG.solarTrailer,
      title: computed(() => t("labels.access")),
      value: STRING_GENERAL.access,
    },
    {
      icon: CONSTANTSVG.haultruck,
      title: computed(() => t("labels.client")),
      value: STRING_GENERAL.client,
    },
  ],
  ADMIN: [
    {
      icon: "mdi-tools",
      title: computed(() => t("sidebar.admin.admiInven")),
      value: VISIBLE_PAGES.management,
    },
    {
      icon: "mdi-file-excel",
      title: computed(() => t("sidebar.admin.admiCSV")),
      value: VISIBLE_PAGES.admincsv,
    },
  ],
  SERVIDORES: isCananea.value ? [
    {
      icon: "mdi-server",
      title: computed(() => t("sidebar.servers")),
      value: VISIBLE_PAGES.servers,
    },
    
  ] : [],
  REPORT: [
    {
      icon: "mdi-text-box-check",
      title: computed(() => t("sidebar.report")),
      value: VISIBLE_PAGES.report,
    },
  ],
  KPI: [
    {
      icon: "mdi-book-open-outline",
      title: computed(() => t("sidebar.kpi.general")),
      value: VISIBLE_PAGES.kpi,
    },
    {icon: 'mdi-video-input-antenna',   title:computed(() => t('sidebar.kpi.allLatency')),    value: VISIBLE_PAGES.allLatency, }
  ],
  IADISTRIBUTION: isDEMO.value
    ? [
        {
          icon: "mdi-chart-line",
          title: computed(() => t("sidebar.analytics.predicts")),
          value: VISIBLE_PAGES.predicts,
        },
      ]
    : [
        {
          icon: "mdi-chart-line",
          title: computed(() => t("sidebar.analytics.predicts")),
          value: VISIBLE_PAGES.predicts,
        },
        {
          icon: "mdi-stairs-up",
          title: computed(() => t("sidebar.analytics.predictsnr")),
          value: VISIBLE_PAGES.predictsnr,
        },
      ],
  DRIVE: !isNacozari.value && !isCollahuasi.value ? [

    {
      icon: "mdi-map-marker-path",
      title: computed(() => t("sidebar.driveHeatmap")),
      value: VISIBLE_PAGES.driveheatmap,
    },
    {
      icon: "mdi-arrow-decision",
      title: computed(() => t("sidebar.bandWidth")),
      value: VISIBLE_PAGES.bandWidth,
    },
    {
      icon: "mdi-car-wireless",
      title: computed(() => t("sidebar.visualMine")),
      value: VISIBLE_PAGES.driveClients,
    }
  ] : [
    {
      icon: "mdi-map-marker-path",
      title: computed(() => t("sidebar.driveHeatmap")),
      value: VISIBLE_PAGES.driveheatmap,
    },
    {
      icon: "mdi-arrow-decision",
      title: computed(() => t("sidebar.bandWidth")),
      value: VISIBLE_PAGES.bandWidth,
    }
  ]
  
  ,
  GESTORFIRST: [
    {
      icon: "mdi-monitor-dashboard",
      title: computed(() => 'dashboard Ejectivo'),
      value: VISIBLE_PAGES.gestorDash,
    },
    {
      icon: "mdi-cog",
      title: computed(() => t("labels.monitoring")),
      value: VISIBLE_PAGES.monitoring,
    },
    {
      icon: "mdi-file-eye",
      title: computed(() => t("labels.configuration")),
      value: VISIBLE_PAGES.config,
    },
    {
      icon: "mdi-chart-bell-curve-cumulative",
      title: computed(() => t("labels.statistics")),
      value: VISIBLE_PAGES.statistics,
    },
    // {
    //   icon: "mdi-chart-bell-curve-cumulative",
    //   title: computed(() => 'drive'),
    //   value: VISIBLE_PAGES.drive,
    // },
    // {
    //   icon: "mdi-chart-bell-curve-cumulative",
    //   title: computed(() => 'drive rajant'),
    //   value: VISIBLE_PAGES.driverajant,
    // },
  ],
  GESTORTAREAS: [
    {
      icon: "mdi-folder-star-multiple-outline",
      title: computed(() => t("labels.taskmanag")),
      value: "",
    },
  ],
  RESET: [
    {
      icon: "mdi-ballot-outline",
      title: computed(() => t("sidebar.reset")),
      value: VISIBLE_PAGES.reset,
    },
  ],
  ENERGY: [
    {
      icon: "mdi-lightning-bolt",
      title: computed(() => t("sidebar.energy")),
      value: VISIBLE_PAGES.energy,
    },
  ],
};
/**
 * Component
 */
const storeDrawer = computed(() => store.state.drawer);
const drawer = ref(true);
const temporary = ref(false);
const dashActive = ref(true);
const items = ref(SIDEBAR_ITEMS.FIRSTS);
const kpi = ref(SIDEBAR_ITEMS.KPI);
const admin = ref(SIDEBAR_ITEMS.ADMIN);
const reportItems = ref(SIDEBAR_ITEMS.REPORT);
const dashboardItem = ref(SIDEBAR_ITEMS.DASHBOARD);
const drive = ref(SIDEBAR_ITEMS.DRIVE);
const itemsGestor = ref(SIDEBAR_ITEMS.GESTORFIRST);
const servidores = ref(SIDEBAR_ITEMS.SERVIDORES)
const gestorTareas = ref(SIDEBAR_ITEMS.GESTORTAREAS);
const resetItems = ref(SIDEBAR_ITEMS.RESET);
// const energyItem = ref(SIDEBAR_ITEMS.ENERGY);





const TEPEOCA_DRAWER:SIDEBAR = {
  VIEWS:[
    {
      icon: "mdi-developer-board",
      title: computed(() => t("labels.dashboard")),
      value: VISIBLE_PAGES.tepeaca.dashboard,
    },
    // {
    //   icon: "mdi-book-open-outline",
    //   title: computed(() => t("sidebar.kpi.general")),
    //   value: VISIBLE_PAGES.tepeaca.kpi,
    // },
    {
      icon: "mdi-map-clock-outline",
      title: computed(() => 'Histórico'),
      value: VISIBLE_PAGES.tepeaca.playback,
    },
    {
      icon: "mdi-tools",
      title: computed(() => t("sidebar.admin.admiInven")),
      value: VISIBLE_PAGES.tepeaca.administracion,
    },
  ]
}

const finalTEPEOCA = ref(TEPEOCA_DRAWER.VIEWS)

//==================================================//
//===================== METHODS ====================//
//==================================================//

/**
 * Commit to Store to showView
 */

watch(storeDrawer, (b: boolean) => {
  drawer.value = b;
});

watch(drawer, (b: boolean) => {
  b ? store.commit("yesShowDrawer") : store.commit("noShowDrawer");
});

const showKPI = (value: string) => {
  store.commit("postKPIValue", value);
};

const changeActive = (isActive: boolean) => {
  dashActive.value = isActive;
};

const changeTepeacaView = (viewPage: string) => {
   router.push(`/smartlink/cemex/${viewPage}`);
};

const changeView = (viewPage: string) => {
  router.push(`/smartlink/${viewPage}`);
};

const changeGTView = () => {
  window.open("https://smartlink.hcgpe.com/GestorDeTareas", "_blank");
};

const changeViewhash = (viewPage: string) => {
  router.push(`/smartlink/topology#${viewPage}`);
};

onMounted(() => {
  if (mobile.value === true) store.commit("noShowDrawer");
});

/**
 * Son los estilos que mando desde el TS hacia el CSS, en este caso
 * los colores del scrollbar del drawer, cuando se expande demasiado
 */
const styles = computed(() => ({
  "--varColorDrawer": colorDrawer.value,
}));

return (_ctx: any,_cache: any) => {
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list_group = _resolveComponent("v-list-group")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_navigation_drawer = _resolveComponent("v-navigation-drawer")!

  return (_openBlock(), _createElementBlock("div", {
    style: _normalizeStyle(styles.value),
    class: "sideBarCard"
  }, [
    _createVNode(_component_v_navigation_drawer, {
      modelValue: drawer.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((drawer).value = $event)),
      rail: !_unref(mobile),
      "expand-on-hover": !_unref(mobile),
      temporary: _unref(mobile),
      class: _normalizeClass(["navDrawerFixed", _unref(mobile) ? 'ml-0' : 'ml-1']),
      color: colorDrawer.value
    }, {
      default: _withCtx(() => [
        (!isTepeaca.value)
          ? (_openBlock(), _createBlock(_component_v_list, {
              key: 0,
              nav: ""
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dashboardItem.value, (item, i) => {
                  return (_openBlock(), _createBlock(_component_v_list_item, {
                    link: "",
                    key: i,
                    value: item.value,
                    title: item.title,
                    class: "nav_item_title",
                    "prepend-icon": item.icon,
                    onClick: ($event: any) => (changeActive(true), changeView(item.value)),
                    active: dashActive.value
                  }, null, 8, ["value", "title", "prepend-icon", "onClick", "active"]))
                }), 128)),
                (!isRAOS.value && !isLIMA.value)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_1, [
                      _createVNode(_component_v_list_group, { value: "topology" }, {
                        activator: _withCtx(({ props }) => [
                          _createVNode(_component_v_list_item, _mergeProps({ class: "nav_item_title" }, props, {
                            title: _unref(t)('sidebar.topology'),
                            "prepend-icon": "mdi-state-machine"
                          }), null, 16, ["title"])
                        ]),
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.value, (item, key) => {
                            return (_openBlock(), _createBlock(_component_v_list_item, {
                              link: "",
                              key: key,
                              class: "nav_item_title",
                              title: item.title,
                              value: item.value,
                              onClick: ($event: any) => (changeActive(false), changeViewhash(item.value))
                            }, {
                              prepend: _withCtx(() => [
                                _createElementVNode("div", _hoisted_2, [
                                  (_openBlock(), _createElementBlock("svg", _hoisted_3, [
                                    _createElementVNode("g", {
                                      innerHTML: item.icon
                                    }, null, 8, _hoisted_4)
                                  ]))
                                ])
                              ]),
                              _: 2
                            }, 1032, ["title", "value", "onClick"]))
                          }), 128))
                        ]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true),
                _createVNode(_component_v_list_group, { value: "admin" }, {
                  activator: _withCtx(({ props }) => [
                    _createVNode(_component_v_list_item, _mergeProps({ class: "nav_item_title" }, props, {
                      title: _unref(t)('sidebar.admin.title'),
                      "prepend-icon": "mdi-file-cabinet"
                    }), null, 16, ["title"])
                  ]),
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(admin.value, (item, i) => {
                      return (_openBlock(), _createBlock(_component_v_list_item, {
                        key: i,
                        value: item.value,
                        title: item.title,
                        class: "nav_item_title",
                        "prepend-icon": item.icon,
                        onClick: ($event: any) => (changeActive(false), changeView(item.value))
                      }, null, 8, ["value", "title", "prepend-icon", "onClick"]))
                    }), 128))
                  ]),
                  _: 1
                }),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(kpi.value, (item, i) => {
                  return (_openBlock(), _createBlock(_component_v_list_item, {
                    key: i,
                    value: item.value,
                    title: item.title,
                    class: "nav_item_title",
                    "prepend-icon": item.icon,
                    onClick: ($event: any) => (changeActive(false), changeView(item.value))
                  }, null, 8, ["value", "title", "prepend-icon", "onClick"]))
                }), 128)),
                (!isRAOS.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(reportItems.value, (item, i) => {
                        return (_openBlock(), _createBlock(_component_v_list_item, {
                          key: i,
                          value: item.value,
                          title: item.title,
                          class: "nav_item_title",
                          "prepend-icon": item.icon,
                          onClick: ($event: any) => (changeActive(false), changeView(item.value))
                        }, null, 8, ["value", "title", "prepend-icon", "onClick"]))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(drive.value, (item, key) => {
                  return (_openBlock(), _createBlock(_component_v_list_item, {
                    link: "",
                    key: key,
                    class: "nav_item_title",
                    "prepend-icon": item.icon,
                    title: item.title,
                    value: item.value,
                    onClick: ($event: any) => (changeActive(false), changeView(item.value))
                  }, null, 8, ["prepend-icon", "title", "value", "onClick"]))
                }), 128)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(servidores.value, (item, key) => {
                  return (_openBlock(), _createBlock(_component_v_list_item, {
                    link: "",
                    key: key,
                    class: "nav_item_title",
                    "prepend-icon": item.icon,
                    title: item.title,
                    value: item.value,
                    onClick: ($event: any) => (changeActive(false), changeView(item.value))
                  }, null, 8, ["prepend-icon", "title", "value", "onClick"]))
                }), 128)),
                (isDEMO.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      _createVNode(_component_v_list_group, { value: "GestorHCKlink" }, {
                        activator: _withCtx(({ props }) => [
                          _createVNode(_component_v_list_item, _mergeProps({ class: "nav_item_title" }, props, {
                            title: 'LTE/5G HCG-LINK',
                            "prepend-icon": "mdi-state-machine"
                          }), null, 16)
                        ]),
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(itemsGestor.value, (item, key) => {
                            return (_openBlock(), _createBlock(_component_v_list_item, {
                              link: "",
                              key: key,
                              class: "nav_item_title",
                              title: item.title,
                              value: item.value,
                              "prepend-icon": item.icon,
                              onClick: ($event: any) => (changeActive(false), changeView(item.value))
                            }, null, 8, ["title", "value", "prepend-icon", "onClick"]))
                          }), 128))
                        ]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }))
          : (_openBlock(), _createBlock(_component_v_list, {
              key: 1,
              nav: ""
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(finalTEPEOCA.value, (item, i) => {
                  return (_openBlock(), _createBlock(_component_v_list_item, {
                    link: "",
                    key: i,
                    value: item.value,
                    title: item.title,
                    class: "nav_item_title",
                    "prepend-icon": item.icon,
                    onClick: ($event: any) => (changeActive(true), changeTepeacaView(item.value))
                  }, null, 8, ["value", "title", "prepend-icon", "onClick"]))
                }), 128))
              ]),
              _: 1
            }))
      ]),
      _: 1
    }, 8, ["modelValue", "rail", "expand-on-hover", "temporary", "class", "color"])
  ], 4))
}
}

})